import { gql } from "__generated__/gql";
import { CargoActionDocumentStatus } from "__generated__/enums";

export const mergeDocuments_mutation = gql(`#graphql
	mutation mergeDocuments($input: ProcessDocumentInput!) {
		mergeDocuments(input: $input)
	}
`);

export const processDocuments_mutation = gql(`#graphql
mutation markDocumentsAsProcessed($ids: [Int!]!) {
	setDocumentsStatus(ids: $ids, status: PROCESSED) {
		id
		status
	}
}
`);

export const publishDocuments_mutation = gql(`#graphql
mutation publishDocuments($charterId: Long!, $sendEmailIds: [Int!]!, $publishIds: [Int!]!, $processIds: [Int!]!, $notes: String, $sendEmail: Boolean!) {
	sendCargoDocumentsPdfs(charterId: $charterId, documentIds: $sendEmailIds, notes: $notes) @include(if: $sendEmail)
	markAsProcessed: setDocumentsStatus(ids: $processIds, status: PROCESSED) {
		id
		status
	}
	markAsPublished: setDocumentsStatus(ids: $publishIds, status: PUBLISHED) {
		id
		status
	}
}
`);
export const extractDocument_mutation = gql(`#graphql
	mutation extractDocument($input: ProcessDocumentInput!) {
		extractDocument(input: $input)
	}
`);
export const generate_timesheets_mutation = gql(`#graphql
mutation generateTimesheets($cargoIds: [Long!]!, $cargoActionTypes: [CallType!]!) {
	generateTimesheets(cargoIds: $cargoIds, cargoActionTypes: $cargoActionTypes)
}
`);

// Util functions
export const parseExtractPageNumbers = (pageNumbers: string | undefined): number[] => {
	if (pageNumbers == null || pageNumbers.trim().length === 0) {
		return [];
	}

	const commaSeparatedPages = pageNumbers.split(",").map(n => n.trim());

	// check if the user defined ranges (e.g. 1, 2-5, 6-8)
	const pages = commaSeparatedPages.flatMap(n => {
		const range = n.match(/^(\d+)\s*-\s*(\d+)$/);

		if (range != null) {
			const x = Number(range[1]);
			const y = Number(range[2]);

			const lowest = Math.min(x, y);
			const highest = Math.max(x, y);

			return Array.from({ length: highest - lowest + 1 }, (_, i) => lowest + i);
		}

		if (/^\d+$/.test(n)) {
			return [ Number(n) ]; // just return the page number, no range
		}

		return [];
	}).filter(n => n > 0);

	return Array.from(new Set(pages))
		.sort((x, y) => x - y);
};

export const getCargoDocumentStatusColor = (documentStatus: CargoActionDocumentStatus) => {
	switch (documentStatus) {
		case CargoActionDocumentStatus.NoDocumentsCreated:
			return "#8da9c4";
		case CargoActionDocumentStatus.NewDocumentsCreated:
			return "#f68010";
		case CargoActionDocumentStatus.AllDocumentsProcessed:
			return "#74e12a";
		default:
			return "#f4f4f4";
	}
};
